import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";

function editorStateReducer(state, action) {
  switch (action.type) {
    case 'document_saved':
      return _objectSpread({}, state, {
        serverContent: action.payload,
        isSaving: false
      });

    case 'document_saving':
      return _objectSpread({}, state, {
        isSaving: true
      });

    default:
      return state;
  }
}

export default editorStateReducer;